<template>
  <div class="profile-sidebar">
    <SidebarContent>
        <template #content>
          <div class="scrollable-container sidebar">
            <TeamLogo />
            <h4 v-if="!noTeam">
                {{teamName}}<br>
            </h4>
            <!-- <div class="subtitle">Hier verwalten Sie Ihr Team. Um weitere Mitglieder zu Ihrem Team hinzuzufügen, klicken Sie auf <b>Einladen</b>.</div> -->
          </div>
        </template>
        <template #actions>
          <div class="action-buttons">
            <!-- <button class="button primary tall">Einladen</button> -->
            <!-- <button class="button ghost tall" @click="onPlan">Second important Task</button> -->
          </div>
        </template>
    </SidebarContent>
  </div>
</template>

<script>
import SidebarContent from "./SidebarContent.vue"
import TeamMixin from "../mixins/TeamMixin.vue";
import TeamLogo from "./TeamLogo.vue";

export default {
  name: 'TeamSidebar',
  mixins: [TeamMixin],
  components: {
      SidebarContent,
      TeamLogo,
  },
  props: {
  },
  data: function() {
    return {
      showSaveConfirmation: false,
      saveButtonDisabled: false
    }
  },
  methods: {
    onSaveProfile() {
      this.saveButtonDisabled = true
      this.$store.dispatch("user/saveProfile").then( () => {
        setTimeout( () => {
          this.showSaveConfirmation = true
          setTimeout( () => {
            this.showSaveConfirmation = false
            this.saveButtonDisabled = false
          }, 1000)
        }, 200)
      })
    }
  },
  computed: {
    profile() {
      return this.$store.getters["user/profile"]
    },
    user() {
      return this.profile.user
    },
    rev() {
      return this.profile._rev
    },
  },
}
</script>

<style scoped>
.profile-sidebar {
    display: flex;
    flex-direction: column;
    align-content: space-between;
    height: 100%;
}

.action-buttons {
  display: flex;
  flex-direction: column;
}
.action-buttons .button {
  margin-right: 30px;
}
.subtitle {
  margin-bottom: 20px;
  font-size: 18px;
  color: var(--c-deep-grey);
  letter-spacing: 0.5px;
}
</style>
